import { DEFAULT_CREDIT_TABS } from '../../../Blotters/Credit/defaults';
import type { CreditTabProps } from '../../../Blotters/Credit/types';
import { MobileBlotterPanel, type MobileBlotterPanelProps } from './MobileBlotterPanel';

/** Placeholder-only mobile credit content; uses `TradingPlaceholder` via `MobileBlotterPanel`. */
export function MobileCreditBlotter(props: Omit<MobileBlotterPanelProps<CreditTabProps>, 'defaultTabs'>) {
  return <MobileBlotterPanel<CreditTabProps> {...props} defaultTabs={DEFAULT_CREDIT_TABS} />;
}
